import * as React from "react";
import * as classNames from "classnames";
import { ReactNode } from "react";
import { ButtonStyle } from "CommonControls/ButtonStyle";
import IEmptyState from "EmptyState";
import { ButtonIconPosition } from "CommonControls/ButtonIconPosition";

export interface IButtonProps {
    style?: ButtonStyle,
    padded?: boolean,
    wide?: boolean,
    text?: string,
    normalIconImage?: string,
    iconPosition: ButtonIconPosition,
    link?: string,
    onClick?: ((sender: Button, event: React.MouseEvent<HTMLElement>) => void),
}

export default class Button extends React.PureComponent<IButtonProps, IEmptyState> {
    private _htmlElement?: HTMLElement;

    public static defaultProps: Partial<IButtonProps> = {
        style: ButtonStyle.StandardPrimary,
        padded: true,
        wide: false,
        iconPosition: ButtonIconPosition.Left
    };

    constructor(props: IButtonProps) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    private handleClick(event: React.MouseEvent<HTMLElement>): boolean | void {
        if (this.props.onClick != undefined) {
            this.props.onClick(this, event);
        }
        if (this._htmlElement != undefined) {
            this._htmlElement.blur();
        }
        event.stopPropagation();
    }

    public render(): ReactNode {
        const className: string = classNames(
            "button no-underline",
            {
                "standard-button primary": this.props.style == ButtonStyle.StandardPrimary,
                "standard-button default": this.props.style == ButtonStyle.StandardDefault,
                "standard-button transparent": this.props.style == ButtonStyle.StandardTransparent,
            }, {
                "padded": this.props.padded,
                "wide": this.props.wide
            });
        const icon: JSX.Element = <div className="icon" style={{ backgroundImage: "url(" + this.props.normalIconImage + ")" }}></div>
        const content: JSX.Element =
            <div className="content">
                {this.props.normalIconImage && this.props.iconPosition == ButtonIconPosition.Left && icon}
                {this.props.text != undefined &&
                    <div className="text">{this.props.text}</div>
                }
                {this.props.normalIconImage && this.props.iconPosition == ButtonIconPosition.Right && icon}
            </div>
        return (
            this.props.link == undefined ?
                <button ref={c => this._htmlElement = c!} className={className} onClick={this.handleClick} >
                    {content}
                </button>
                :
                <a ref={c => this._htmlElement = c!} className={className} href={this.props.link} target="_blank"
                     onClick={this.handleClick}>
                    {content}
                </a>
        );
    }
}

